import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { ColorComponent } from './ColorComponent'; // Impor komponen UI
import { useUpdateOta } from '../../../services/ota-channel/hooks/useUpdateOta';
import { UpdateOtaChannelFormData } from '../../../services/ota-channel/schema/UpdateOtaChannelSchema';
import { OtaSingleResponse } from '../../../services/ota-channel/response/IndexOtaChannel';

/**
 * Props untuk OtaFieldColorComponent.
 * Kita butuh seluruh objek 'ota' untuk bisa membuat 'formData' yang valid.
 */
interface OtaFieldColorComponentProps {
    ota: OtaSingleResponse; // Ganti 'Ota' dengan tipe data objek ota/agent Anda
}

const OtaFieldColorComponent: React.FC<OtaFieldColorComponentProps> = ({ ota }) => {
    // 1. Panggil hook mutasi spesifik Anda
    const { mutate: updateOta, isPending } = useUpdateOta();
    const queryClient = useQueryClient();

    /**
     * Fungsi inilah yang akan kita teruskan ke onColorUpdate di ColorComponent.
     * Fungsi ini tahu bagaimana cara membangun payload yang benar untuk useUpdateOta.
     */
    const handleUpdateColor = (newColor: string) => {
        // 2. Siapkan formData yang valid sesuai dengan skema Zod Anda.
        // Kita menyalin data ota yang ada dan hanya menimpa field 'color'.
        // Ini memastikan semua field lain yang mungkin required tetap ada.
        const formData: UpdateOtaChannelFormData = {
            primary_color: newColor, // Timpa dengan warna baru
        };

        // 3. Panggil mutasi dengan signature yang benar
        updateOta({
            agentId: ota.id, // atau ota.agentId, sesuaikan dengan data Anda
            formData: formData
        }, {
            onSuccess: async () => {
                toast.success(`Color for ${ota.name} updated successfully!`);
                // 4. Refetch data agar seluruh UI sinkron
                await queryClient.refetchQueries({ queryKey: ['ota'] }); // Ganti dengan query key yang benar
            },
            onError: (error: any) => {
                // Hook Anda sudah punya penanganan error internal,
                // kita hanya perlu menampilkan notifikasi ke pengguna.
                const errorMessage = error?.response?.data?.message || 'Failed to update color.';
                toast.error(errorMessage);
            }
        });
    };

    return (
        // 5. Render komponen UI dan teruskan props yang relevan
        <ColorComponent
            color={ota.primary_color}
            onColorUpdate={handleUpdateColor}
            isUpdating={isPending}
        />
    );
};

export default OtaFieldColorComponent;